import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { _OopsDomService, _OopsType } from '@lvflanders/bar';

export function barPageNotFoundGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        if (!route.routeConfig?.component) return true;
        const oopsDomService = inject(_OopsDomService);
        oopsDomService.showOops({ type: _OopsType.NotFound });
        return true;
    };
}
